import React, { memo, useCallback } from "react";

import { KeyValuePair, TableColumn } from "../../../../../../models";
import { TableCellValue } from "./table-row/table-cell-value";
import { TableCell } from "./table-row/table-cell";
import TableRow from "./table-row";
import { JackpotTypes } from "../../../../../../enums/jackpot";

interface TableBodyProps {
  rowKey?: string;
  rowClicked: boolean;
  rowClickedKey: string;
  isDrawPrintIcon?: boolean;
  rows: Array<KeyValuePair>;
  columns: Array<TableColumn>;
  openJackpotStream?: (row: any) => void;
  onRowClick: (row: any, index: number) => void;
}

const TableBody: React.FC<TableBodyProps> = ({
  rows,
  columns,
  onRowClick,
  rowClicked,
  rowClickedKey,
  rowKey = "id",
  isDrawPrintIcon,
  openJackpotStream,
}) => {

  const drawColumn = useCallback((col: TableColumn, row: KeyValuePair, index: number) => {if (col.hideColumn) return;

      return (
        <>
          <TableCell
            key={col.dataKey}
            hasTooltip={col.hasTooltip}
            tooltipDirection={col.tooltipDirection}
            children={col.colRenderer ? (col.colRenderer(row[col.dataKey], row, index)
            ) : (
              <>
                {/*ToDo: If you need to display the text on a single line, add the "one-line" class on the "table-inner-text" element. */}
                <TableCellValue
                  hasTooltip={col.hasTooltip}
                  tooltipDirection={col.tooltipDirection}
                  value={col.formatter?.(row[col.dataKey]) || `${row[col.dataKey] ?? "-"}`}
                />

                {/*/!*ToDo: where you need to use the tooltip, on its parent element you need to add 'has-tooltip' class*!/*/}

                {/*/!*ToDo: for tooltip positioning on 'tooltip-wrp' need to add 'bottom-right','bottom-left','top-right', 'top-left'*!/*/}

              </>
            )
            }
          />
        </>

      );
  }, [columns]);

  return (
    <div className="main-table-body">
      <div className="scroll-holder">
        <div className="scrollable-container">
          {rows.length ? (
            rows.map((row, index) => (
              <TableRow
                key={row[rowKey]}
                barCode={row.barcode}
                ticketId={row.ticketId}
                status={row?.status}
                rowClicked={rowClicked}
                paidAmount={row?.paidAmount}
                rowClickedKey={row[rowClickedKey]}
                isDrawPrintIcon={isDrawPrintIcon}
                onClick={() => onRowClick(row, index)}
                isDrawJackpotIcon={row.level !== JackpotTypes.Game}
                openJackpotStream={openJackpotStream ? () => openJackpotStream(row) : undefined}
              >
                {columns.map((col) => drawColumn(col, row, index))}
              </TableRow>
            ))
          ) : (
            <div className="empty-result">
              <span className="empty-result-logo" />
              <p className="empty-result-text">No Results</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(TableBody);
